import { render, staticRenderFns } from "./relationCreate.vue?vue&type=template&id=675bfa2f&scoped=true"
import script from "./relationCreate.vue?vue&type=script&lang=ts"
export * from "./relationCreate.vue?vue&type=script&lang=ts"
import style0 from "./relationCreate.vue?vue&type=style&index=0&id=675bfa2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675bfa2f",
  null
  
)

export default component.exports